<!-- Purchase Manager Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <!-- Search -->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search purchase managers..."
          (keyup.enter)="applyFilters()"
        />
      </div>
    </div>

    <!-- Card Toolbar -->
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-purchase-manager-table-toolbar="base">
        <!-- Search Button -->
        <button
          type="button"
          class="btn btn-sm btn-dark me-3"
          [class.active]="showFiltersForm"
          (click)="toggleFilters()"
        >
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>

        <!-- Add Purchase Manager Button -->
        <button
          type="button"
          class="btn btn-primary"
          (click)="openAddPurchaseManagerModal()"
        >
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Purchase Manager
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Form -->
  <div class="card-body border-top pt-6" *ngIf="showFiltersForm">
    <div class="row mb-6">
      <div class="col-md-3">
        <label class="form-label">Date From</label>
        <input
          type="date"
          class="form-control form-control-solid"
          [(ngModel)]="filters.date_from"
        />
      </div>
      <div class="col-md-3">
        <label class="form-label">Date To</label>
        <input
          type="date"
          class="form-control form-control-solid"
          [(ngModel)]="filters.date_to"
        />
      </div>
      <div class="col-md-3">
        <label class="form-label">Location</label>
        <input
          type="text"
          class="form-control form-control-solid"
          [(ngModel)]="filters.location"
          placeholder="Enter location"
        />
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <button
          type="button"
          class="btn btn-primary me-2"
          (click)="applyFilters()"
        >
          Apply Filters
        </button>
        <button
          type="button"
          class="btn btn-light"
          (click)="clearFilters()"
        >
          Clear
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Purchase Managers Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-150px">Vehicle</th>
            <th class="min-w-120px">Amount</th>
            <th class="min-w-120px">Purchase Date</th>
            <th class="min-w-120px">Location</th>
            <th class="min-w-150px">Vendor</th>
            <th class="min-w-200px">Admin Comment</th>
            <th class="min-w-80px">Invoice</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="8" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading purchase managers...
              </div>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="!isLoading && purchaseManagers.length === 0">
            <td colspan="8" class="text-center py-5">
              <div class="text-muted">No purchase managers found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let purchaseManager of purchaseManagers; trackBy: trackByFn">
            <!-- Vehicle -->
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-40px me-3" *ngIf="purchaseManager.vehicle?.pictures?.length">
                  <img [src]="purchaseManager.vehicle.pictures[0]"
                       [alt]="getVehicleDisplayName(purchaseManager.vehicle)"
                       class="symbol-label"
                       style="object-fit: cover;">
                </div>
                <div class="d-flex flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ getVehicleDisplayName(purchaseManager.vehicle) }}
                  </span>
                  <span class="text-muted fs-7" *ngIf="purchaseManager.vehicle?.chassis_no">
                    Chassis: {{ purchaseManager.vehicle.chassis_no }}
                  </span>
                </div>
              </div>
            </td>

            <!-- Amount -->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ formatAmount(purchaseManager.amount) }}
              </span>
            </td>

            <!-- Purchase Date -->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ formatDate(purchaseManager.purchase_date) }}
              </span>
            </td>

            <!-- Location -->
            <td>
              <span class="text-dark fw-bold d-block fs-6">
                {{ purchaseManager.location || '-' }}
              </span>
            </td>

            <!-- Vendor -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark fw-bold text-hover-primary fs-6">
                  {{ getVendorDisplayName(purchaseManager.vendor) }}
                </span>
                <span class="text-muted fs-7" *ngIf="purchaseManager.vendor?.email">
                  {{ purchaseManager.vendor.email }}
                </span>
              </div>
            </td>

            <!-- Admin Comment -->
            <td>
              <span class="text-dark fs-6" [title]="purchaseManager.admin_comment">
                {{ purchaseManager.admin_comment ? (purchaseManager.admin_comment.length > 50 ? (purchaseManager.admin_comment | slice:0:50) + '...' : purchaseManager.admin_comment) : '-' }}
              </span>
            </td>

            <!-- Invoice File -->
            <td class="">
              <button
                *ngIf="purchaseManager.invoice_file"
                type="button"
                class="btn btn-sm btn-light-primary"
                (click)="openFile(purchaseManager.invoice_file)"
                title="View Invoice"
              >
                <i class="ki-duotone ki-document fs-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
              <span *ngIf="!purchaseManager.invoice_file" class="text-muted">-</span>
            </td>

            <!-- Actions -->
             <td class="text-end">
              <div class="d-flex justify-content-end">
                <!-- Edit Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-primary me-2"
                  (click)="openEditPurchaseManagerModal(purchaseManager)"
                  title="Edit">
                  <i class="ki-duotone ki-pencil fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Documents Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-info me-2"
                  (click)="openUploadDocsModal(purchaseManager)"
                  title="Documents">
                  <i class="ki-duotone ki-folder fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <!-- <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-danger"
                  (click)="deleteVendor(vendor)"
                  title="Delete vendor">
                  <i class="ki-duotone ki-trash fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button> -->
              </div>
            </td>
            <!--  -->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && purchaseManagers.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Purchase Manager Upload Documents Modal -->
<app-purchase-manager-upload-docs
  (documentsUploaded)="onDocumentsUploaded()">
</app-purchase-manager-upload-docs>
